/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Name of an event emitted over the websocket
 */
export type WebsocketsEvents = (typeof WebsocketsEvents)[keyof typeof WebsocketsEvents];

export const WebsocketsEvents = {
  DEVICE_UPTIME_STATUS_CHANGED: 'device:uptime_status_changed',
  DEVICE_UPDATED: 'device:updated',
  INCIDENTS_CREATED: 'incidents:created',
  INCIDENTS_PROGRESS: 'incidents:progress',
  INCIDENTS_RESOLVED: 'incidents:resolved',
  WORKFLOW_TRIGGERED: 'workflow:triggered',
  WORKFLOW_ATTEMPTS_UPDATED: 'workflow:attempts_updated',
  WORKFLOW_STATUS_CHANGED: 'workflow:status_changed',
} as const;
